const initState = {
    error: {
        isError: false,
        status: '',
    },
    channels: null,
    isPending: false,
    isSuccess: false,
    isAlert: false,
    alertMsg: '',
    info: {
        isInfo: false,
        infoText: '',
    },
    isNoDel: false,
    noDelReason: '',
    isScrollStop: false,
    isScrollKill: false,
    isSearchEmpty: false,

    lectures: null,
    isLecturesEmpty: false,
    lecturesOffset: 0,
    lecturesCount: 0,
    lecturesIsMore: true,
    lectureMenuShow: false,
    currentLecture: {},
    currentLectureInfo: {},
    isShowDelLectureConfirm: false,
    lectureKeyword: '',
    moveToChannelId: '',
    isShowAtList: false,

    isShowMoveChannels: false,
    isChannelsEmpty: false,
    channelMenuShow: false,
    currentChannel: {},
    currentChannelIndex: '',
    isShowDelChannelConfirm: false,
    channelKeyword: '',
}

export default function (state = initState, action) {
    switch (action.type) {
        case 'LIVEROOM_SETTING_LECTURE_SET_INIT':
            return initState
        case 'LIVEROOM_SETTING_LECTURE_SET_ERROR':
            return { ...state, error: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_LECTURES':
            return { ...state, lectures: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_CHANNELS':
            return { ...state, channels: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_PENDING':
            return { ...state, isPending: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_SUCCESS':
            return { ...state, isSuccess: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_ALERT':
            return { ...state, isAlert: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_ALERT_MSG':
            return { ...state, alertMsg: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_INFO':
            return { ...state, info: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_NO_DEL':
            return { ...state, isNoDel: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_LEC_MENU_SHOW':
            return { ...state, lectureMenuShow: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_CHA_MENU_SHOW':
            return { ...state, channelMenuShow: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_CURRENT_LECTURE':
            return { ...state, currentLecture: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_CURRENT_CHANNEL':
            return { ...state, currentChannel: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_SHOW_DEL_LEC':
            return { ...state, isShowDelLectureConfirm: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_SHOW_MOVE_CHANNELS':
            return { ...state, isShowMoveChannels: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_SHOW_DEL_CHA':
            return { ...state, isShowDelChannelConfirm: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_NO_DEL_REASON':
            return { ...state, noDelReason: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_LECTURE_KEYWORD':
            return { ...state, lectureKeyword: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_CHANNEL_KEYWORD':
            return { ...state, channelKeyword: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_CURRENT_LECTURE_INFO':
            return { ...state, currentLectureInfo: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_MOVE_TO_CHANNEL_ID':
            return { ...state, moveToChannelId: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_SHOW_AT_LIST':
            return { ...state, isShowAtList: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_SCROLL_STOP':
            return { ...state, isScrollStop: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_SCROLL_KILL':
            return { ...state, isScrollKill: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_LECTURES_OFFSET':
            return { ...state, lecturesOffset: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_LECTURES_IS_MORE':
            return { ...state, lecturesIsMore: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_LECTURES_COUNT':
            return { ...state, lecturesCount: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_SEARCH_EMPTY':
            return { ...state, isSearchEmpty: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_LECTURES_EMPTY':
            return { ...state, isLecturesEmpty: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_IS_CHANNELS_EMPTY':
            return { ...state, isChannelsEmpty: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_SET_CURRENT_CHANNEL_INDEX':
            return { ...state, currentChannelIndex: action.payload }
        case 'LIVEROOM_SETTING_LECTURE_EXCHANGE_CHANNEL':
            return { ...state, channels: exchangeChannel(state.channels, action.channelA, action.channelB) }
        default:
            return state
    }
}

function exchangeChannel(channels, channelAIndex, channelBIndex) {
    channels = channels.slice()
    const channelA = channels.splice(channelAIndex, 1, channels[channelBIndex])
    channels.splice(channelBIndex, 1, channelA[0])
    return channels
}


// WEBPACK FOOTER //
// ./src/reducers/liveroomSettingLecture.js